$(document).ready(function() {
    var href = window.location.href;
    var lang = $('html').attr('lang').substring(0,2);
    var freqPrd = [
        "ZATX0188",
        "ZATX0188-S",
        "BWMX2028-P",
        "BWMX2035-P"
    ];
    var isFreqPrdPage =
        href.indexOf("/products/") > -1
        && freqPrd.indexOf($("span.variant-sku").text()) > -1;

    if (isFreqPrdPage) {
        // in case a product is a Frequency regulator we add the optimal poolpump simulator/calculator to the upsell
        var prepareFREQupsell = function (waitElement) {
            waitForElementToDisplay(waitElement,
                function() {
                    $(".ppcs-list-title-c").each( function() {
                        var text = $(this).text().trim();
                        if (text.indexOf('Harmo')!== -1) {
                           switch(lang) {
                                case "nl":
                                    var label = "Hulp bij energie- en filtratie-efficiënte pompkeuze";
                                    break;
                                case "de":
                                    var label = "Hilfe bei energie- und filtrationseffizienter Pumpenauswahl";
                                    break;
                                case "fr":
                                    var label = "Aide au choix pompe efficace en énergie ainsi qu'en filtration";
                                    break;
                                case "es":
                                    var label = "Ayuda elegir bomba eficiente energía y filtración";
                                    break;
                                case "pt":
                                    var label = "Ajuda na escolha bomba eficiente energia e filtragem";
                                    break;
                                case "it":
                                    var label = "Aiuto scelta pompa efficiente energia e filtrazione";
                                    break;
                                case "da":
                                    var label = "Hjælp til valg af energi- og filtreringseffektiv pumpe";
                                    break;
                                case "en":
                                    var label = "Help choosing an energy and filtration efficient pump";
                                    break;
                            }
                        
                            $(this).closest(".ppcse-list-lt-label-cont, .ppcse-m-list-lt-cont").append(
                                '<div id="pump-simulator-link"><p><a href="#shopify-section-template--25231971549532__rich_text_jgUwxa"><span style="font-size: 1em;">🔢</span> '
                                + label +'</a> ✅</p><div>'
                            );
                            $(this).closest(".ppcse-list-lt-label-cont").addClass("pump-upsell").attr("id", "pump-upsell");
                            $(this).closest(".ppcse-m-list-lt-cont").addClass("pump-upsell").attr("id", "pump-upsell");
                        }
                    });
                },1000,15000
            );
        };
        prepareFREQupsell("lb-product-page-cross-sell-ew");
    }
});

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        }
        else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}